<template>
	<div id="recap" class="row-padding col-padding"> 
		<div class="go-back flex v-center" @click="setRecap(false)">
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M3.4748 12L10.7623 19.2875C10.9956 19.5208 11.1102 19.7958 11.1061 20.1125C11.1019 20.4292 10.9831 20.7042 10.7498 20.9375C10.5165 21.1708 10.2415 21.2875 9.9248 21.2875C9.60814 21.2875 9.33314 21.1708 9.0998 20.9375L1.4748 13.325C1.28314 13.1333 1.14355 12.925 1.05605 12.7C0.968555 12.475 0.924805 12.2417 0.924805 12C0.924805 11.7583 0.968555 11.525 1.05605 11.3C1.14355 11.075 1.28314 10.8667 1.4748 10.675L9.0998 3.05001C9.33314 2.81667 9.61022 2.70209 9.93105 2.70626C10.2519 2.71042 10.529 2.82917 10.7623 3.06251C10.9956 3.29584 11.1123 3.57084 11.1123 3.88751C11.1123 4.20417 10.9956 4.47917 10.7623 4.71251L3.4748 12Z" fill="black"/>
			</svg>
			
			<div>{{ locale.back_to_configurator }}</div>
		</div>
		
		<div class="very-large-font row-padding">{{ locale.send_request }}</div>
		
		<div class="info flex">
			<div class="columns-6">
				<Transition name="fade">
					<div class="image" v-if="image1 != ''"><img :src="image1"/></div>
				</Transition>
			</div>
			<div class="columns-6">
				<div class="medium-font bottom-padding">{{ locale.form_title }}</div>
			
				<div class="input-wrapper">
					<div class="title">{{ locale.first_name }}</div>
					<input name="name" type="text" v-model="first_name">
				</div>
				
				<div class="input-wrapper">
					<div class="title">{{ locale.last_name }}</div>
					<input name="last_name" type="text" v-model="last_name">
				</div>
				
				<div class="input-wrapper">
					<div class="title">{{ locale.nation }}</div>
					<select name="nation" v-model="nation">
						<option value="">{{ locale.select }}</option>
						<option v-for="nation in locale.nations">{{ nation }}</option>
					</select>
				</div>
				
				<div class="input-wrapper">
					<div class="title">{{ locale.city }}</div>
					<input name="city" type="text" v-model="city">
				</div>
				
				<div class="input-wrapper">
					<div class="name">{{ locale.profile }}</div>
					<Switch
						class="small-padding"
						v-model="profile"
						:options="[
							{ text: locale.private, value: 'Private' },
							{ text: locale.professional, value: 'Professional' }
						]"
					/>
				</div>
				
				<div class="input-wrapper" v-if="profile == 'Professional'">
					<div class="title">{{ locale.profession }}</div>
					<select name="profession" v-model="profession">
						<option value="">{{ locale.select }}</option>
						<option v-for="profession in locale.professions">{{ profession }}</option>
					</select>
				</div>
				
				<div class="input-wrapper">
					<div class="title">{{ locale.mail }}</div>
					<input name="mail" type="mail" v-model="mail">
				</div>
				
				<div class="input-wrapper">
					<div class="title">{{ locale.privacy_policy }}*</div>
					
					<div class="flex v-center">
						<input id="privacy" type="checkbox" v-model="privacy">
						<label for="privacy">{{ locale.policy_agree }} <a href="https://www.iubenda.com/privacy-policy/18523641" target="_blank">{{ locale.privacy_policy }}*</a></label>
					</div>
				</div>
				
				<div class="errors row-padding">
					<div v-if="error == 'generic'" class="generic-error error">{{ locale.generic_form_error }}</div>
					<div v-if="error == 'privacy'" class="privacy-error error">{{ locale.privacy_form_error }}</div>
				</div>
				
				<div class="button filled" @click="submitForm">{{ locale.send }}</div>
			</div>
		</div>
	
		<Transition name="fade">
			<div class="overlay" v-if="loading"></div>
		</Transition>
	
		<div class="end-screen flex v-center h-center" :class="{show : end}">
			<div class="text-center">
				<div class="huge-font">{{ locale.thanks }}</div>
				
				<div class="large-font double-row-padding">
					{{ locale.thanks_text1 }}<br>
					{{ locale.thanks_text2 }}
				</div>
				
				<div class="actions flex h-center">
					<a class="button" target="_blank" href="https://martinelliluce.it/it/">{{ locale.discover_multidot }}</a>
					<div class="button filled" @click="reloadPage">{{ locale.configure_multidot }}</div>
				</div>
				
				<div class="logo">
					<svg width="100" height="40" viewBox="0 0 100 40" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_2273_352)">
						<path d="M72.4428 27.0423H94.8856C97.3647 27.0423 99.3746 25.0245 99.3746 22.5356C99.3746 20.0467 97.3647 18.0289 94.8856 18.0289H74.6866L62.5679 1.8068C61.0803 -0.184042 58.2674 -0.587894 56.2836 0.905609C56.151 1.00134 55.9156 1.20551 55.8031 1.32442L45.5111 11.657V4.51036C45.5111 2.02218 43.5012 0.00442179 41.0228 0.00442179C39.9814 -0.0576517 38.5414 0.541395 37.8486 1.32442L27.5566 11.657V4.51036C27.5566 2.02218 25.5467 0.00442179 23.0683 0.00442179C22.0269 -0.0576517 20.5877 0.541395 19.8941 1.32442L1.93963 19.3497C0.18679 21.1094 0.18679 23.9625 1.93963 25.7223C3.69247 27.482 6.53441 27.482 8.28725 25.7223L18.5793 15.3897V22.5356C18.5793 25.0245 20.5892 27.0423 23.0683 27.0423C24.1097 27.1044 25.549 26.5053 26.2425 25.7223L36.5346 15.3897V22.5356C36.5346 25.0245 38.5444 27.0423 41.0236 27.0423C42.065 27.1044 43.5042 26.5053 44.1978 25.7223L58.4931 11.3706L68.8537 25.2392C69.5599 26.3034 71.1735 27.1126 72.4451 27.0415L72.4428 27.0423Z" fill="black"/>
						<path d="M21.3337 39.4308C21.0461 38.9162 21.0916 38.1026 21.0916 37.2956C21.0916 36.3032 21.1184 35.2046 21.0677 34.3034C21.0573 34.1261 21.0119 33.9646 20.9709 33.8015C20.8495 33.3199 20.5694 32.9849 20.2133 32.7418C20.1552 32.7014 20.0859 32.6618 20.0203 32.6281C19.8147 32.5249 19.5994 32.4397 19.3596 32.3776C19.2814 32.3574 19.1942 32.3469 19.1093 32.329C18.5498 32.2101 17.8675 32.1704 17.1836 32.1914C16.7612 32.2048 16.3381 32.2549 15.9917 32.329C15.8196 32.3664 15.6848 32.3933 15.5403 32.4344C15.4695 32.4546 15.3973 32.4815 15.331 32.507C15.2565 32.5354 15.1656 32.572 15.1134 32.6042C15.0859 32.6214 15.0553 32.6259 15.033 32.6364C14.7432 32.768 14.4966 32.9669 14.3 33.186C13.9439 33.5824 13.7345 34.1463 13.7442 34.9009C14.6866 34.9196 15.6647 34.9039 16.6204 34.9091C16.6197 34.8037 16.6249 34.7349 16.6361 34.6496C16.6487 34.5606 16.6651 34.4948 16.7165 34.4313C16.7843 34.3497 16.8663 34.2824 16.9981 34.2376C17.2097 34.1665 17.5926 34.165 17.796 34.2301C18.0023 34.2959 18.225 34.5389 18.0857 34.8044C18.0775 34.8201 18.0172 34.9009 17.9814 34.9256C17.8429 35.0221 17.6544 35.0363 17.5226 35.0632C17.2514 35.1171 16.9914 35.135 16.7329 35.1761C16.3783 35.2322 16.0223 35.2674 15.6781 35.3459C15.5127 35.384 14.8974 35.5792 14.7514 35.6368C14.6203 35.6892 14.408 35.8073 14.3484 35.847C14.2143 35.9375 13.8984 36.2321 13.7845 36.3967C13.5729 36.7025 13.4515 37.0795 13.4217 37.5454C13.4165 37.6292 13.4157 37.7241 13.4217 37.8124C13.4284 37.8984 13.4314 37.9934 13.4463 38.0876C13.5468 38.7211 13.8776 39.2019 14.3082 39.5026C14.3506 39.5325 14.3998 39.5632 14.4452 39.5923C14.4847 39.6178 14.5443 39.6439 14.5741 39.6656C14.6225 39.7 14.6881 39.7195 14.7514 39.7464C15.0196 39.8593 15.3369 39.9356 15.6535 39.9805C15.7891 39.9999 15.9299 39.9969 16.0804 39.9969C16.356 39.9969 16.6435 39.9894 16.9266 39.9319C17.1858 39.8795 17.4138 39.8167 17.635 39.7299C17.7639 39.6783 17.8988 39.5991 18.006 39.5273C18.053 39.4959 18.0969 39.4697 18.1431 39.4383C18.1669 39.4226 18.1729 39.4136 18.2258 39.3739C18.2355 39.54 18.298 39.6746 18.3368 39.8107C19.3968 39.8242 20.5142 39.8242 21.575 39.8107C21.5095 39.7165 21.4827 39.6828 21.4409 39.6207C21.397 39.5557 21.3717 39.5086 21.3337 39.4308ZM17.9904 37.5865C17.9166 37.7204 17.8041 37.8281 17.6596 37.9014C17.4585 38.0053 17.124 38.048 16.8782 37.9418C16.8149 37.9141 16.727 37.861 16.6763 37.8124C16.6406 37.778 16.607 37.7309 16.5795 37.6666C16.5273 37.5461 16.5743 37.3726 16.6361 37.2702C16.7612 37.0466 17.1076 37.0346 17.4011 36.9793C17.5173 36.9576 17.6336 36.9179 17.7475 36.8903C17.8734 36.8603 17.9852 36.8057 18.0939 36.7773C18.0991 36.7758 18.1029 36.7751 18.1096 36.7736C18.1431 37.1019 18.1014 37.3809 17.9889 37.5858L17.9904 37.5865Z" fill="black"/>
						<path d="M0.588379 32.3764L3.59346 32.3787V32.971L3.60463 32.9762C4.36224 32.3622 4.67586 32.1895 5.68748 32.1895C6.47414 32.1895 7.0902 32.4265 7.66306 33.1482C7.77554 33.0622 8.32829 32.1895 10.14 32.1895C11.9517 32.1895 12.64 33.5087 12.64 34.7135V39.8185H9.56042V36.3125C9.55818 35.5437 9.65428 34.7479 8.79611 34.7539C8.13833 34.7591 8.15323 35.5377 8.15323 36.3125V39.8185H5.10643L5.11164 36.2399C5.11164 35.5369 5.13623 34.7472 4.38458 34.7539C3.68211 34.7599 3.66721 35.5377 3.66721 36.3125V39.8185H0.588379V32.3757V32.3764Z" fill="black"/>
						<path d="M22.1045 32.3764H25.0582L25.0679 33.0316L25.0872 33.0121C25.634 32.4587 25.9804 32.1895 27.03 32.1895C27.3213 32.1895 27.5984 32.2328 27.8748 32.3039V35.1682C27.582 35.0403 27.3213 34.9072 26.738 34.9072C25.6012 34.9072 25.2131 35.2864 25.2131 36.8786V39.8185H22.1045V32.3757V32.3764Z" fill="black"/>
						<path d="M32.6147 32.3973H34.0621V34.4569H32.6296L32.6333 36.714C32.6333 37.3789 32.6855 37.4619 33.4148 37.4619C33.6338 37.4619 33.8647 37.4365 34.0807 37.3789L34.0941 39.7863C33.4788 39.8573 32.8568 39.9306 32.2437 39.9306C31.0183 39.9306 29.6051 39.6629 29.6051 37.6967L29.6029 34.4569H28.3745V32.3973H29.588L29.5903 30.4438H32.6184L32.6147 32.3973Z" fill="black"/>
						<path d="M38.1302 29.7012H35.061V31.9986H38.1302V29.7012Z" fill="black"/>
						<path d="M38.1302 32.3955H35.061V39.8189H38.1302V32.3955Z" fill="black"/>
						<path d="M67.7977 29.7046H64.7285V32.0021H67.7977V29.7046Z" fill="black"/>
						<path d="M67.7977 32.3994H64.7285V39.8228H67.7977V32.3994Z" fill="black"/>
						<path d="M63.6126 29.7012H60.5435V39.8274H63.6126V29.7012Z" fill="black"/>
						<path d="M59.4354 29.6519H56.3662V39.7781H59.4354V29.6519Z" fill="black"/>
						<path d="M73.8357 29.6519H70.7666V39.7781H73.8357V29.6519Z" fill="black"/>
						<path d="M39.2127 32.3764H42.1567L42.1589 32.9403L42.1879 32.9194C42.6371 32.6217 42.5306 32.6763 42.9158 32.4864C43.3009 32.2964 43.7911 32.1895 44.3624 32.1895C45.6854 32.1895 46.8952 33.0069 46.8952 34.7135V39.8185H43.7799V35.9176C43.7627 35.2991 43.8156 34.7532 43.0789 34.7539C42.5254 34.7539 42.2557 35.1129 42.2528 35.8884V39.8178H39.2119V32.3749L39.2127 32.3764Z" fill="black"/>
						<path d="M95.2007 32.1646C92.8594 32.1646 91.2891 33.9273 91.2891 36.0916C91.2891 38.5708 93.0732 39.9753 95.4428 39.9753C97.1271 39.9753 98.9455 38.9665 99.3143 37.3772H96.45C96.2302 37.7624 95.8064 37.9164 95.3505 37.8985C94.9273 37.882 94.3515 37.7026 94.28 36.8575H99.4111C99.4111 33.9624 98.141 32.1646 95.2 32.1646H95.2007ZM94.3165 35.1523C94.4148 34.5996 94.7873 34.2937 95.4331 34.2937C95.9911 34.2937 96.3852 34.6782 96.3852 35.1523H94.3165Z" fill="black"/>
						<path d="M82.5204 39.8107H79.5764L79.5742 39.2468L79.5452 39.2678C79.096 39.5654 79.2025 39.5108 78.8174 39.7008C78.4322 39.8908 77.942 39.9977 77.3707 39.9977C76.0477 39.9977 74.8379 39.1803 74.8379 37.4736V32.3687H77.9532V36.2696C77.9704 36.8881 77.9175 37.434 78.6542 37.4332C79.2077 37.4332 79.4774 37.0743 79.4804 36.2987V32.3694H82.5212V39.8122L82.5204 39.8107Z" fill="black"/>
						<path d="M88.0583 35.3849C88.0486 35.0117 87.954 34.8988 87.869 34.8143C87.6999 34.6453 87.4735 34.569 87.1912 34.5742C86.4298 34.5877 86.1862 35.2107 86.1862 36.1029C86.1862 36.9951 86.4254 37.6166 87.1912 37.6181C87.7983 37.6188 88.0724 37.197 88.129 36.6159H91.0209C90.9151 37.7048 90.3534 38.612 89.6755 39.1505C89.0118 39.6747 88.1223 39.9582 87.1345 39.9582C84.9325 39.9582 83.167 38.4273 83.167 36.1029C83.167 33.7785 84.9318 32.2334 87.1345 32.2334C89.093 32.2334 90.9464 33.2191 90.9464 35.3924L88.0583 35.3849Z" fill="black"/>
						<path d="M51.4751 32.1895C49.1338 32.1895 47.5635 33.9522 47.5635 36.1165C47.5635 38.5957 49.3476 40.0002 51.7172 40.0002C53.4016 40.0002 55.22 38.9914 55.5887 37.4021H52.7244C52.5047 37.7873 52.0808 37.9413 51.6249 37.9234C51.2018 37.9069 50.6259 37.7275 50.5544 36.8824H55.6855C55.6855 33.9873 54.4154 32.1895 51.4744 32.1895H51.4751ZM50.5909 35.1772C50.6892 34.6245 51.0617 34.3186 51.7076 34.3186C52.2655 34.3186 52.6596 34.7031 52.6596 35.1772H50.5909Z" fill="black"/>
						</g>
						<defs>
						<clipPath id="clip0_2273_352">
						<rect width="98.8235" height="40" fill="white" transform="translate(0.588379)"/>
						</clipPath>
						</defs>
					</svg>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapMutations } from 'vuex'
	import Switch from '@/components/Switch.vue'
	import axios from 'axios';
	
	export default {
		name: 'Recap',
		components: { Switch },
		data: function () { return {
			first_name : '',
			last_name : '',
			nation : '',
			city : '',
			profile : '',
			profession : '',
			mail : '',
			privacy : false,
			error : null,
			end : false,
			loading : false
		}},
		computed: {
			...mapState([
				'locale', 'recap', 'image1', 'configuration_data', 'model_file'
			]),
		},
		methods: {
			...mapMutations([
				'setRecap', 'stopAnimation'
			]),
			submitForm(){
				
				if( this.first_name == '' || this.last_name == '' || this.profile == '' || this.mail == '' || (this.profile == 'professional' && this.profession == '') ){
					this.error = 'generic';
					return;
				}
				
				if( this.privacy == false  ){
					this.error = 'privacy';
					return;
				}
				
				this.loading = true;
				this.stopAnimation();
				
				let data = new FormData;
				data.append('action', 'send_configuration');
				data.append('linear_mode', true);
				data.append('first_name', this.first_name);
				data.append('last_name', this.last_name);
				data.append('nation', this.nation);
				data.append('city', this.city);
				data.append('profile', this.profile);
				data.append('profession', this.profession);
				data.append('mail', this.mail);
				data.append('image1', this.image1);
				data.append('configuration', this.configuration_data);
				data.append('model', new File([this.model_file], 'model.zip'), 'model.zip');
					
				axios.post(ajaxurl, data, {
					headers: { 'Content-Type': 'multipart/form-data' }
				}).then( response => {
					this.end = true;
				})
			},
			reloadPage(){
				window.location.reload();
			}
		}
	}
</script>

<style scoped lang="scss">
	#recap{
		position: absolute;
		top: 0;
		left: 100%;
		width: 100%;
		height: 100%;
		background: white;
		z-index: 3;
		transition: left 0.5s;
		overflow-y: auto;
		overflow-x: hidden;
		
		&.show{
			left: 0;
		}
				
		.go-back{
			white-space: nowrap;
			cursor: pointer;
			
			svg{
				margin-right: 10px;
			}
		}
		
		.info{
			gap: 20px;
			
			.image{
				position: relative;
				padding-top: 100%;
				
				img{
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
			}
			
			.input-wrapper{
				width: 100%;
				margin-bottom: 12px;
				
				.title{
					margin-bottom: 4px;
				}
				select,
				input:not([type=checkbox]){
					width: 100%;
					text-align: left;
				}
				select{
					text-transform: capitalize;
					
					option{
						text-transform: capitalize;
					}
				}
				input[type=checkbox]{
					margin-top: 10px;
				}
				label{
					margin-left: 10px;
				}
				
				&.disabled{
					opacity: 0.5; 
					pointer-events: none;
				}
			}
			
			.error{
				color: #C30101;
			}
		}
		
		.overlay{
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: white;
			opacity: 0.5;
			z-index: 3;
		}
		
		.end-screen{
			position: absolute;
			top: 0;
			left: 100%;
			width: 100%;
			height: 100%;
			background: #ffe100;
			z-index: 4;
			transition: left 0.5s;
			
			&.show{
				left: 0;
			}
			
			.actions .button{
				margin: 0 20px;
				text-decoration: none;
			}
			
			.logo{
				margin-top: 80px;
			}
		}
	}
</style>
